import { SignedUpload } from "@coworker/apprestructured/src/task-management/types/Upload";
import { useQueries, UseQueryResult } from "@tanstack/react-query";
import {
  getUploadFile,
  UploadFile,
} from "@coworker/apprestructured/src/task-management/services/uploads.service";
import { useCallback, useMemo } from "react";
import {
  Loading,
  LOADING,
} from "@coworker/apprestructured/src/task-management/loading";
import { getUploadFileQueryKey } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";

export function useUploadFiles(
  signedUploads: SignedUpload[] | undefined
): UploadFile[] | Loading {
  const combine = useCallback(
    (results: UseQueryResult<UploadFile, Error>[]): UploadFile[] | Loading => {
      if (signedUploads === undefined) {
        return LOADING;
      } else {
        // Safe cast thanks to the placeholder data below
        return results.map(({ data }) => data as UploadFile);
      }
    },
    [signedUploads]
  );

  const queries = useMemo(() => {
    if (signedUploads === undefined) {
      return [];
    } else {
      return signedUploads.map((signedUpload) => {
        const placeholderData: UploadFile = {
          uploadId: signedUpload.id,
          blob: LOADING,
        };
        return {
          queryKey: getUploadFileQueryKey(signedUpload.id),
          queryFn: () => getUploadFile(signedUpload),
          staleTime: Infinity,
          placeholderData,
        };
      });
    }
  }, [signedUploads]);

  return useQueries({
    queries,
    // Using 'combine' makes the identity of the returned data stable
    combine,
  });
}
